import React, { FC, useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";
import "../../styles/SideNavBar.css";
import { useSelector } from "react-redux";
import { StoreState } from "../../redux/reducers";

export interface MenuItemTypes {
  key: string;
  label: string;
  isTitle?: boolean;
  Icon?: Feather.Icon;
  url?: string;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  target?: string;
  children?: MenuItemTypes[];
}

export const MENU_ITEMS: MenuItemTypes[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    isTitle: false,
    Icon: Feather.Airplay,
    url: "/",
  },
  {
    key: "attendence",
    label: "Attendence",
    url: "/attendance",
    Icon: Feather.Repeat,
  },

  {
    key: "leaverequest",
    label: "Leave Request",
    url: "/employeeLeave",
    isTitle: false,
    Icon: Feather.Layers,
  },

  {
    key: "dailyreport",
    label: "Daily Report",
    url: "/employee_report_user",
    Icon: Feather.Users,
  },
  {
    key: "task",
    label: "Task",
    isTitle: false,
    Icon: Feather.List,
    url: "/task",
  },
  {
    key: "page",
    label: "Page",
    isTitle: false,
    Icon: Feather.PenTool,
    url: "/page",
  },
  {
    key: "holiday",
    label: "Holiday",
    isTitle: false,
    Icon: Feather.BarChart,
    url: "/userHoliday",
  },
  {
    key: "payslip",
    label: "Pay Slip",
    isTitle: false,
    Icon: Feather.Paperclip,
    url: "/payslip",
  },
];

const SideNavBarUser: FC = () => {
  const authUser = useSelector((state: StoreState) => state.authUser);

  const renderMenuItem = (menuItem: MenuItemTypes) => {
    const { Icon } = menuItem;
    return (
      <li className="nav-item" key={menuItem.key}>
        <Link to={menuItem.url || ""} className="nav-link">
          {Icon && <Icon style={{ marginRight: "5px" }} />}
          <p>{menuItem.label}</p>
        </Link>
      </li>
    );
  };

  return (
    <aside
      className="main-sidebar elevation-4"
      style={{ backgroundColor: "#092149", position: "fixed" }}
    >
      <div className="sidebar">
        <div className="user-panel d-flex">
          <div className="info">
            <img
              src={
                process.env.PUBLIC_URL
                  ? process.env.PUBLIC_URL + "img/taskTracker.png"
                  : "../img/taskTracker.png"
              }
              style={{ width: "100%" }}
              alt="College Logo"
            />
          </div>
        </div>
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            data-accordion="false"
          >
            {MENU_ITEMS?.map((menuItem) =>
              menuItem.children ? (
                <MenuItem key={menuItem.key} menuItem={menuItem} />
              ) : (
                renderMenuItem(menuItem)
              ),
            )}
            <li className="nav-item">
              <Link to="/logout" className="nav-link">
                <Feather.LogOut style={{ marginRight: "5px" }} />
                <p>Logout</p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

const MenuItem: FC<{ menuItem: MenuItemTypes }> = ({ menuItem }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const { Icon } = menuItem;

  const handleToggleMenuClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowSubMenu(!showSubMenu);
  };

  return (
    <li className="nav-item" key={menuItem.key}>
      <Link
        to="#"
        className="nav-link"
        onClick={handleToggleMenuClick}
        aria-expanded={showSubMenu}
      >
        {Icon && <Icon style={{ marginRight: "5px" }} />}
        <p>
          {menuItem.label}
          <i
            className={`right fas ${
              !showSubMenu ? "fa-angle-left" : "fa-angle-down"
            }`}
          ></i>
        </p>
      </Link>
      <ul
        className="nav nav-treeview"
        style={{ display: showSubMenu ? "block" : "none" }}
      >
        {menuItem.children?.map((childItem) => (
          <li className="nav-item" key={childItem.key}>
            <Link to={childItem.url || "#"} className="nav-link">
              <i className="fas fa-angle-right nav-icon"></i>
              <p>{childItem.label}</p>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default SideNavBarUser;
